/**
 * A camera reads the same sticker many times a second, and a worker can trigger a wedge twice.
 * The same code inside the window is dropped; anything else is processed.
 */
/** Entries older than the window can never suppress anything, so they are swept at this size. */
const SWEEP_AT = 64;

export function createDeduper(windowMs = 2000, now: () => number = () => Date.now()): (code: string) => boolean {
  const seen = new Map<string, number>();
  return (code: string) => {
    const t = now();
    const prev = seen.get(code);
    // A shift can scan a few thousand distinct boxes without leaving the screen, and every one of
    // them would otherwise sit in here until the screen unmounts. Only codes inside the window can
    // still change an answer, and that is a handful, so a sweep leaves the map effectively empty.
    if (seen.size >= SWEEP_AT) for (const [old, at] of seen) if (t - at >= windowMs) seen.delete(old);
    seen.set(code, t);
    return prev === undefined || t - prev >= windowMs;
  };
}
